<template>
  <ValidationObserver ref="validator">
    <form novalidate class="md-layout generic-form" @submit.prevent="validate">
      <div class="md-layout-item md-medium-size-100 md-size-100">
        <md-card>
          <md-card-content>
            <div class="md-layout">
              <backend-text v-model="mailSetup.host" label="Host" rules="required" class="md-layout-item"></backend-text>
              <backend-text v-model="mailSetup.port" label="Port" rules="required" class="md-layout-item"></backend-text>
              <backend-text v-model="mailSetup.user_name" label="User Name" rules="required" class="md-layout-item"></backend-text>
              <backend-text v-model="mailSetup.password" label="Password" rules="required" class="md-layout-item"></backend-text>
            </div>
            <div class="md-layout">
              <backend-text
                v-model="mailSetup.from"
                label="From"
                rules="required"
                class="md-layout-item md-size-25 md-small-size-100"
              ></backend-text>
              <md-checkbox v-model="mailSetup.explicit_copy_to_sent_folder" class="md-layout-item  md-small-size-100 text-nowrap">
                Explicit copy to sent folder
              </md-checkbox>
              <backend-text
                v-model="mailSetup.sent_folder_name"
                label="Sent folder name"
                class="md-layout-item md-size-50 md-small-size-100"
              ></backend-text>
            </div>
            <div class="md-layout">
              <backend-text
                v-model="mailSetup.time_zone"
                label="Time zone string"
                rules="required"
                class="md-layout-item md-size-25 md-small-size-100"
              ></backend-text>
              <md-checkbox v-model="mailSetup.grouped_by_room_type" class="md-layout-item  md-small-size-100 text-nowrap">
                Grouped by room type
              </md-checkbox>
            </div>
            <div class="md-layout">
              <div class="md-layout-item md-layout" style="padding: 0;">
                <md-checkbox v-model="mailSetup.restrictions_enabled" class="md-layout-item text-nowrap">
                  Restrictions enabled
                </md-checkbox>
                <div class="md-layout-item md-size-30">
                  <week-days-select v-model="mailSetup.restrictions_days_of_week" :errors="[]">
                    <template v-slot:label>Days of the week for restrictions</template>
                  </week-days-select>
                </div>
                <div class="md-layout-item md-size-45">
                  <template v-for="(item, index) in mailSetup.restrictions_times_of_day">
                    <div class="md-layout" :key="index">
                      <backend-text
                        v-model="mailSetup.restrictions_times_of_day[index]"
                        label="Time"
                        rules="required"
                        class="md-layout-item md-size-50"
                      ></backend-text>
                      <md-button
                        v-if="Math.max(1, mailSetup.restrictions_times_of_day.length) > 1"
                        @click="deleteTime(index, 'restrictions')"
                        class="md-white md-just-icon"
                        ><md-icon>delete</md-icon></md-button
                      >
                      <md-button
                        v-if="index + 1 == Math.max(1, mailSetup.restrictions_times_of_day.length)"
                        @click="addTime(index, 'restrictions')"
                        class="md-white md-just-icon"
                        ><md-icon>add</md-icon></md-button
                      >
                    </div>
                  </template>
                </div>
              </div>
              <div class="md-layout-item md-layout" style="padding: 0;">
                <md-checkbox v-model="mailSetup.offers_enabled" class="md-layout-item text-nowrap">
                  Offers enabled
                </md-checkbox>
                <div class="md-layout-item md-size-30">
                  <week-days-select v-model="mailSetup.offers_days_of_week" :errors="[]">
                    <template v-slot:label>Days of the week for offers</template>
                  </week-days-select>
                </div>
                <div class="md-layout-item md-size-45">
                  <template v-for="(item, index) in mailSetup.offers_times_of_day">
                    <div class="md-layout" :key="index">
                      <backend-text
                        v-model="mailSetup.offers_times_of_day[index]"
                        label="Time"
                        rules="required"
                        class="md-layout-item md-size-50"
                      ></backend-text>
                      <md-button
                        v-if="Math.max(1, mailSetup.offers_times_of_day.length) > 1"
                        @click="deleteTime(index, 'offers')"
                        class="md-white md-just-icon"
                        ><md-icon>delete</md-icon></md-button
                      >
                      <md-button
                        v-if="index + 1 == Math.max(1, mailSetup.offers_times_of_day.length)"
                        @click="addTime(index, 'offers')"
                        class="md-white md-just-icon"
                        ><md-icon>add</md-icon></md-button
                      >
                    </div>
                  </template>
                </div>
              </div>
            </div>
            <md-button
              v-if="!!mailSetup.restrictions_emails && mailSetup.restrictions_emails.length === 0"
              @click="addTime(0, 'restrictions_emails')"
              >Add Restrictions emails</md-button
            >
            <md-button v-if="!!mailSetup.offers_emails && mailSetup.offers_emails.length === 0" @click="addTime(0, 'offers_emails')"
              >Add Offers emails</md-button
            >
            <div class="md-layout">
              <div class="md-layout-item md-size-50 md-small-size-100" style="padding: 0;">
                <template v-for="(item, index) in mailSetup.restrictions_emails">
                  <div class="md-layout" :key="index">
                    <backend-text
                      v-model="mailSetup.restrictions_emails[index]"
                      label="Restriction email"
                      rules="required|email"
                      class="md-layout-item "
                    ></backend-text>
                    <md-button
                      v-if="Math.max(1, mailSetup.restrictions_emails.length) > 0"
                      @click="deleteTime(index, 'restrictions_emails')"
                      class="md-white md-just-icon"
                      ><md-icon>delete</md-icon></md-button
                    >
                    <md-button
                      v-if="index + 1 == Math.max(1, mailSetup.restrictions_emails.length)"
                      @click="addTime(index, 'restrictions_emails')"
                      class="md-white md-just-icon"
                      ><md-icon>add</md-icon></md-button
                    >
                  </div>
                </template>
              </div>
              <div class="md-layout-item  md-size-50 md-small-size-100" style="padding: 0;">
                <template v-for="(item, index) in mailSetup.offers_emails">
                  <div class="md-layout" :key="index">
                    <backend-text
                      v-model="mailSetup.offers_emails[index]"
                      label="Offer email"
                      rules="required|email"
                      class="md-layout-item"
                    ></backend-text>
                    <md-button
                      v-if="Math.max(1, mailSetup.offers_emails.length) > 0"
                      @click="deleteTime(index, 'offers_emails')"
                      class="md-white md-just-icon"
                      ><md-icon>delete</md-icon></md-button
                    >
                    <md-button
                      v-if="index + 1 == Math.max(1, mailSetup.offers_emails.length)"
                      @click="addTime(index, 'offers_emails')"
                      class="md-white md-just-icon"
                      ><md-icon>add</md-icon></md-button
                    >
                  </div>
                </template>
              </div>
            </div>
            <div class="md-layout">
              <md-checkbox v-model="mailSetup.separe_open_close_restriction" class="md-layout-item text-nowrap">
                Separate open / close email restrictions
              </md-checkbox>
            </div>
            <div class="md-layout" v-if="edit == true">
              <md-field class="md-layout-item  md-size-25 md-theme-default">
                <label>Logo Hotel (.png only)</label>
                <md-file ref="file" accept=".png" validaty="false" @md-change="fileSelected" />
              </md-field>
              <backend-text
                v-model="mailSetup.logo_heigth"
                label="Heigth in px"
                rules="required"
                class="md-layout-item md-size-10"
                @change="enableImport"
              ></backend-text>
              <backend-text
                v-model="mailSetup.logo_width"
                label="Width in px"
                rules="required"
                class="md-layout-item md-size-10"
                @change="enableImport"
              ></backend-text>
              <div class="md-layout-item md-size-10">
                <md-button class="md-success" :disabled="disabledImport" @click="importFile">
                  Import
                </md-button>
              </div>
            </div>
            <div class="md-layout" v-if="edit == true && mailSetup.has_logo_hotel">
              <div class="md-layout-item">
                <img class="md-elevation-6" :src="urlLogo" :style="logoStyle" />
              </div>
            </div>
          </md-card-content>

          <md-card-actions>
            <md-button class="md-success" type="submit">Save</md-button>
          </md-card-actions>
        </md-card>
      </div>
    </form>
  </ValidationObserver>
</template>

<script>
import MailSetupApi from '@/openapi/src/api/MailSetupApi'
import BackendText from '../../Components/Inputs/BackendText.vue'
import WeekDaysSelect from '@/components/Pricing/Inputs/WeekDaysSelect.vue'

const mailSetupApi = new MailSetupApi()

export default {
  components: {
    BackendText,
    WeekDaysSelect,
  },
  data() {
    return {
      mailSetup: {},
      edit: false,
      fileList: null,
      disabledImport: true,
      urlLogo: null,
      logoStyle: { height: '0px', width: '0px' },
    }
  },
  methods: {
    deleteTime(index, listName) {
      switch (listName) {
        case 'restrictions':
          this.mailSetup.restrictions_times_of_day.splice(index, 1)
          break
        case 'offers':
          this.mailSetup.offers_times_of_day.splice(index, 1)
          break
        case 'restrictions_emails':
          this.mailSetup.restrictions_emails.splice(index, 1)
          break
        case 'offers_emails':
          this.mailSetup.offers_emails.splice(index, 1)
          break

        default:
          break
      }
    },
    addTime(index, listName) {
      switch (listName) {
        case 'restrictions':
          this.mailSetup.restrictions_times_of_day.push('')
          break
        case 'offers':
          this.mailSetup.offers_times_of_day.push('')
          break
        case 'restrictions_emails':
          this.mailSetup.restrictions_emails.push('')
          break
        case 'offers_emails':
          this.mailSetup.offers_emails.push('')
          break

        default:
          break
      }
    },
    getMailSepup() {
      mailSetupApi.getMailSetupDTO(this.$root.hotelId, (error, data) => {
        if (!!data) {
          this.edit = true
          this.mailSetup = data
          if (this.mailSetup.has_logo_hotel === true) {
            this.$nextTick(() => {
              this.fetchLogoHotel()
            })
          }
        } else {
          this.mailSetup = {
            host: null,
            port: null,
            hotel_name: null,
            user_name: null,
            password: null,
            from: null,
            explicit_copy_to_sent_folder: false,
            restrictions_times_of_day: [''],
            offers_enabled: false,
            offers_times_of_day: [''],
            offers_greetings: {},
            offers_body: {},
            restrictions_enabled: false,
            restrictions_greetings: {},
            restrictions_body: {},
            restrictions_close: {},
            restrictions_emails: [],
            offers_emails: [],
            separe_open_close_restriction: false,
            grouped_by_room_type: false,
            time_zone: 'Europe/Madrid',
            logo_heigth: 0,
            logo_width: 0,
          }
        }
      })
    },
    createMailSetup() {
      mailSetupApi.createMailSetupDTO(this.$root.hotelId, this.mailSetup, (error, data) => {
        if (!!error) {
          this.mailSetup = data
        }
      })
      this.$notify({
        timeout: 4500,
        message: 'Mail Setup will be saved shortly',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
      })
    },
    updateMailSetup() {
      mailSetupApi.updateMailSetupDTO(this.$root.hotelId, this.mailSetup, (error, data) => {
        if (!!error) {
          this.mailSetup = data
        }
      })
      this.$notify({
        timeout: 4500,
        message: 'Mail Setup will be saved shortly',
        icon: 'check_box',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: 'info',
      })
    },
    fileSelected(fileList) {
      this.fileList = fileList
      this.enableImport()
    },
    enableImport() {
      if (!this.fileList || !this.mailSetup.logo_heigth > 0 || !this.mailSetup.logo_width > 0) {
        this.disabledImport = true
      } else {
        this.disabledImport = false
      }
    },
    importFile() {
      let url
      let auth = mailSetupApi.apiClient.authentications['bearer-token']
      let token = typeof auth.accessToken === 'function' ? auth.accessToken() : auth.accessToken

      const formData = new FormData()
      formData.append('logo_hotel', this.fileList[0])
      formData.append('logo_heigth', this.mailSetup.logo_heigth)
      formData.append('logo_width', this.mailSetup.logo_width)

      url = mailSetupApi.apiClient.buildUrl(
        '/mail-setup/{hotelId}/logo',
        {
          hotelId: this.$root.hotelId,
          channelManagerId: this.channelManager,
        },
        null
      )

      fetch(url, {
        method: 'PUT',
        headers: new Headers({
          Authorization: 'Bearer ' + token,
          ContentType: 'multipart/form-data',
        }),
        body: formData,
      })
        .then(() => {
          this.fileList = null
          this.fileSelected(this.fileList)
          this.$refs.file.clearField()
          this.$refs.file.$refs.inputFile.value = null
          Swal.fire({
            icon: 'success',
            title: 'The changes has been saved',
            showConfirmButton: false,
            timer: 2000,
          })
        })
        .catch((error) => ('Error al enviar y procesar el fichero', error))
    },
    fetchLogoHotel() {
      let url
      let auth = mailSetupApi.apiClient.authentications['bearer-token']
      let token = typeof auth.accessToken === 'function' ? auth.accessToken() : auth.accessToken

      url = mailSetupApi.apiClient.buildUrl(
        '/mail-setup/{hotelId}/logo',
        {
          hotelId: this.$root.hotelId,
        },
        null
      )

      fetch(url, {
        method: 'GET',
        headers: new Headers({
          Authorization: 'Bearer ' + token,
          accept: 'application/octet-stream',
        }),
      })
        .then((response) => {
          return response.blob()
        })
        .then((blob) => {
          this.urlLogo = window.URL.createObjectURL(blob)
          this.logoStyle = {
            height: `${this.mailSetup.logo_heigth}px`,
            width: `${this.mailSetup.logo_width}px`,
          }
        })
        .catch((error) => ('Error al descargar el logo', error))
    },
    async validate() {
      const isValid = await this.$refs.validator.validate()

      if (isValid) {
        if (this.edit === true) {
          return this.updateMailSetup()
        } else {
          return this.createMailSetup()
        }
      }
    },
  },
  mounted() {
    this.getMailSepup()
  },
}
</script>

<style lang="scss"></style>
